import { fromClass } from "fw-model";

export class DocumentProvider {
  ProviderKey: string;
  DocumentTypes: string[];
}
